// Constants and configurations for invoice management

export const statusColors = {
  draft: 'bg-gray-100 text-gray-800',
  sent: 'bg-blue-100 text-blue-800',
  outstanding: 'bg-orange-100 text-orange-800',
  viewed: 'bg-purple-100 text-purple-800',
  partial: 'bg-yellow-100 text-yellow-800',
  paid: 'bg-green-100 text-green-800',
  overdue: 'bg-red-100 text-red-800',
  cancelled: 'bg-gray-100 text-gray-800'
};

export const statusOptions = [
  { value: '', label: 'All Statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'outstanding', label: 'Outstanding' },
  { value: 'viewed', label: 'Viewed' },
  { value: 'partial', label: 'Partial' },
  { value: 'paid', label: 'Paid' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'cancelled', label: 'Cancelled' }
];

export const itemsPerPage = 50;

export const defaultFilters = {
  location: '',
  class: '',
  status: '',
  datePreset: '',
  dateFrom: '',
  dateTo: ''
};

export const datePresetOptions = [
  { value: '', label: 'All Dates' },
  { value: 'today', label: 'Today' },
  { value: '7', label: 'Last 7 Days' },
  { value: '30', label: 'Last 30 Days' },
  { value: '90', label: 'Last 90 Days' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'this_year', label: 'This Year' },
  { value: 'custom', label: 'Custom Range' }
];

export const getDateRangeFromPreset = (preset, dateFrom, dateTo) => {
  if (preset === 'custom') return { from: dateFrom, to: dateTo };
  if (!preset) return { from: '', to: '' };

  const today = new Date();
  const to = today.toISOString().slice(0, 10);

  if (preset === 'today') {
    return { from: to, to };
  }
  if (preset === 'this_month') {
    const from = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10);
    return { from, to };
  }
  if (preset === 'last_month') {
    const from = new Date(today.getFullYear(), today.getMonth() - 1, 1).toISOString().slice(0, 10);
    const lastDay = new Date(today.getFullYear(), today.getMonth(), 0).toISOString().slice(0, 10);
    return { from, to: lastDay };
  }
  if (preset === 'this_year') {
    const from = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10);
    return { from, to };
  }

  const days = parseInt(preset, 10);
  const from = new Date(today.getTime() - days * 86400000).toISOString().slice(0, 10);
  return { from, to };
};